export default __webpack_public_path__ + "static/media/Mask-Group-3.622862dc.png";